import { render, staticRenderFns } from "./SolicitacaoReembolso.vue?vue&type=template&id=828a9752"
import script from "./SolicitacaoReembolso.vue?vue&type=script&lang=js"
export * from "./SolicitacaoReembolso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports